import { render, staticRenderFns } from "./phonePassAndCaptcha.vue?vue&type=template&id=6fee038a&scoped=true"
import script from "./phonePassAndCaptcha.vue?vue&type=script&lang=js"
export * from "./phonePassAndCaptcha.vue?vue&type=script&lang=js"
import style0 from "./phonePassAndCaptcha.vue?vue&type=style&index=0&id=6fee038a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee038a",
  null
  
)

export default component.exports